<template>
  <div>
    <b-card>
      <div class="organism-ticket-management_header card-padding flex-wrap">
        <span class="header__label">Ticket Management</span>
        <atom-button
          buttonId="create-new-ticket"
          class="header__button mt-1 mt-md-0 ml-md-2"
          buttonStyle="border"
          @click="goToCreateTicket"
        >
          <template>Create New Ticket</template>
        </atom-button>
      </div>
      <div class="filter-container card-padding pt-0">
        <div class="row mt-0">
          <div class="col-12 col-lg-3 d-flex justify-content-between">
            <atom-input
              v-model="filterList.ticketId"
              title="Ticket ID"
              placeholder="Ticket ID"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-6 d-flex justify-content-between">
            <atom-input
              v-model="filterList.subjectDetail"
              title="Subject/Detail"
              placeholder="Subject/Detail"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-3 d-flex justify-content-between">
            <atom-multi-select
              title="Status"
              placeholder="All Status"
              v-model="filterList.status"
              label="name"
              :option="statusOption"
            ></atom-multi-select>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-lg-3 w-100">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--start"
                title="Start Date"
                v-model="filterList.dateTime.start"
                :maxDate="
                  filterList.dateTime.end
                    ? filterList.dateTime.end
                    : filterList.dateTime.now
                "
                type="dateNtime"
                placeholder="Select Start Date"
                class="molecule-date-picker-period--start"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div class="col-12 col-lg-3 w-100">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--en"
                title="End Date"
                v-model="filterList.dateTime.end"
                :minDate="filterList.dateTime.start"
                :maxDate="filterList.dateTime.now"
                type="dateNtime"
                placeholder="Select End Date"
                class="molecule-date-picker-period--end"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div class="col-12 col-lg-3 d-flex">
            <div class="d-flex flex-column justify-content-center">
              <label>Filter Date?</label>
              <atom-switch
                v-model="filterList.isEnableDate"
                class="filter__switch"
              ></atom-switch>
            </div>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 table-wrapper">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="fields"
            :hover="true"
            @row-clicked="selectRow"
            show-empty
          >
            <template #head(selected)> Select </template>
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="badgeVariant(data.value)"
                class="badge--width"
                >{{ badgeStatus(data.value) }}</b-badge
              >
            </template>
            <template #cell(id)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(createdDate)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div>
            </template>
            <template #cell(content)="data">
              <div class="content-container-width">
                <div class="header">{{ data.value.subject }}</div>
                <div class="sub-header d-flex">
                  <span class="custom-ticket-detail-max-width"
                    >{{ data.value.detail }}
                  </span>
                </div>
              </div>
            </template>
            <template #cell(lastUpdated)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div>
            </template>
            <template #cell(communication)="data">
              <div v-if="data.value.createdBy">
                <span class="header">{{ data.value.createdBy }}</span
                ><br />
                <span class="sub-header">{{ data.value.createdAt }}</span
                ><br />
                <div class="custom-max-width d-flex sub-header">
                  <span class="custom-sub-max-width">{{
                    data.value.threadMessage
                  }}</span>
                  <div
                    class="custom-margin-left-6"
                    :id="'ticket-threadMessage' + data.index"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      size="12"
                      class="alert__icon"
                    />
                  </div>
                  <b-tooltip
                    :target="'ticket-threadMessage' + data.index"
                    placement="right"
                    boundary="window"
                    variant="primary"
                  >
                    <div class="description__container">
                      <div>{{ data.value.threadMessage }}</div>
                    </div>
                  </b-tooltip>
                </div>
              </div>
              <div v-else>No Reply</div>
            </template>
            <template #cell(deleteIcon)="data">
              <atom-button
                buttonId="button-delete"
                iconLeft="Trash2Icon"
                buttonStyle="flat"
                buttonColor="secondary"
                :isDisable="!(data.item.status === 'OPENED')"
                @click="clickDeleteTicket(data)"
              ></atom-button>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="height: 1px"></footer>

    <!-- Modal Start-->
    <section name="modal">
      <molecule-modal-dialog
        modalId="ticket-management__confirm-delete"
        :isTextCenter="true"
        :textTitle="`Do you want to delete\n“${ticketId}” ?`"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        @clickButtonLeft="clickConfirmDeleteTicket"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </div>
</template>

<script>
import mixinsDateTime from "@/mixins/mixinsDatetime"
import {
  BCard,
  BTable,
  BBadge,
  BPagination,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import Ripple from "vue-ripple-directive"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"

export default {
  name: "OrganismTicketManangment",
  components: {
    BCard,
    BTable,
    BPagination,
    BBadge,
    BTooltip,
    AtomMultiSelect,
    AtomButton,
    AtomInput,
    AtomSwitch,
    AtomDatepicker,
    MoleculeModalDialog,
    MoleculePaginationWithPerPage,
  },
  mixins: [mixinsDateTime],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    statusOption: {
      required: true,
      type: Array,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: Number,
      required: false,
      default: 1,
    },
    directives: {
      "b-tooltip": VBTooltip,
      Ripple,
    },
  },
  data() {
    return {
      ticketId: null,
      modalId: null,
    }
  },
  methods: {
    // filter
    // click button search
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    // click delete
    clickDeleteTicket(data) {
      this.ticketId = data.item.id

      this.modalId = "ticket-management__confirm-delete"
      this.openModal(this.modalId)
    },
    // click confirm delete
    clickConfirmDeleteTicket() {
      this.$emit("clickDelete", this.ticketId)
      this.closeModal()
    },

    badgeVariant(status) {
      if (status === "OPENED") return "light-primary"
      else if (status === "IN_PROGRESS") return "light-warning"
      else return "light-secondary"
    },
    badgeStatus(status) {
      if (status === "OPENED") return "Opened"
      else if (status === "IN_PROGRESS") return "In Progress"
      else return "Closed"
    },
    selectRow(record, index) {
      this.$emit("clickRow", record, index)
    },
    goToCreateTicket() {
      this.$router.push({ name: "externalCreateNewTicket" })
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 500px;
  max-height: calc(100vh - 625px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.organism-ticket-management_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.content-container-width {
  min-width: 200px;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.custom-max-width {
  max-width: 200px;
}

.custom-sub-max-width {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @supports (-webkit-line-clamp: 3) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}

.custom-ticket-detail-max-width {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;

  @supports (-webkit-line-clamp: 4) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}
</style>
